var SpinnerGroup, SpinnerView;

SpinnerView = require('../../../spinner/frontend/views/spinner');

module.exports = SpinnerGroup = {
  spinners: {},
  addSpinner: function(name, options) {
    return this.spinners[name] = (new SpinnerView(options)).render();
  },
  removeSpinner: function(name) {
    var ref;
    if ((ref = this.spinners[name]) != null) {
      ref.remove();
    }
    return delete this.spinners[name];
  },
  start: function(name, options) {
    var ref, spinner;
    spinner = (ref = this.spinners[name]) != null ? ref : this.addSpinner(name, options).render();
    return spinner != null ? spinner.start() : void 0;
  },
  stop: function(name, options) {
    var ref, spinner;
    if (options != null ? options.remove : void 0) {
      return this.removeSpinner(name);
    }
    if (!((ref = (spinner = this.spinners[name])) != null ? ref.isRunning() : void 0)) {
      return;
    }
    return spinner.stop();
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9icm93c2UvZnJvbnRlbmQvaGVscGVycy9zcGlubmVyX2dyb3VwLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2Fic2hhcm1hL25hcGlzdHJhbm8vYnVpbGQvMTQ4NjY3NTYyNDI3NC03NDM3L3N0YWdpbmctcGVyZi0yMDE3LjAyLjA5XzAwLjM1L2dvb2RzL21vZHVsZXMvYnJvd3NlL2Zyb250ZW5kL2hlbHBlcnMvc3Bpbm5lcl9ncm91cC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxXQUFBLEdBQWMsT0FBQSxDQUFRLHlDQUFSOztBQUVkLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLFlBQUEsR0FDZjtFQUFBLFFBQUEsRUFBVSxFQUFWO0VBRUEsVUFBQSxFQUFZLFNBQUMsSUFBRCxFQUFPLE9BQVA7V0FDVixJQUFDLENBQUEsUUFBUyxDQUFBLElBQUEsQ0FBVixHQUFrQixDQUFLLElBQUEsV0FBQSxDQUFZLE9BQVosQ0FBTCxDQUEwQixDQUFDLE1BQTNCLENBQUE7RUFEUixDQUZaO0VBS0EsYUFBQSxFQUFlLFNBQUMsSUFBRDtBQUNiLFFBQUE7O1NBQWUsQ0FBRSxNQUFqQixDQUFBOztXQUNBLE9BQU8sSUFBQyxDQUFBLFFBQVMsQ0FBQSxJQUFBO0VBRkosQ0FMZjtFQVNBLEtBQUEsRUFBTyxTQUFDLElBQUQsRUFBTyxPQUFQO0FBQ0wsUUFBQTtJQUFBLE9BQUEsK0NBQTRCLElBQUMsQ0FBQSxVQUFELENBQVksSUFBWixFQUFrQixPQUFsQixDQUEwQixDQUFDLE1BQTNCLENBQUE7NkJBQzVCLE9BQU8sQ0FBRSxLQUFULENBQUE7RUFGSyxDQVRQO0VBYUEsSUFBQSxFQUFNLFNBQUMsSUFBRCxFQUFPLE9BQVA7QUFDSixRQUFBO0lBQUEsc0JBQStCLE9BQU8sQ0FBRSxlQUF4QztBQUFBLGFBQU8sSUFBQyxDQUFBLGFBQUQsQ0FBZSxJQUFmLEVBQVA7O0lBQ0EsSUFBQSx1REFBeUMsQ0FBRSxTQUE3QixDQUFBLFdBQWQ7QUFBQSxhQUFBOztXQUNBLE9BQU8sQ0FBQyxJQUFSLENBQUE7RUFISSxDQWJOIn0=
